import type { Job } from '@common/types';

const ALLOWED_STATUS = new Set(['digitized']);

const isFormEditable = (job: Job): boolean => {
  return ALLOWED_STATUS.has(job.status) ? true : false;
};

export default isFormEditable;
